import { render, staticRenderFns } from "./PricesTable.vue?vue&type=template&id=30c5324d&scoped=true&"
import script from "./PricesTable.vue?vue&type=script&lang=js&"
export * from "./PricesTable.vue?vue&type=script&lang=js&"
import style0 from "./PricesTable.vue?vue&type=style&index=0&id=30c5324d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c5324d",
  null
  
)

export default component.exports